
import PropTypes from 'prop-types'
import React from 'react'
import { format } from 'url'
import ShowHide from '../ShowHide'
import Link from '../Link'
import Copy from '../Copy'
import Space from '../Space'
import Code from '../Code'
import './run-admin.css'

const RunAdmin = props => {
  const { kind, sourceId, warehouseId, run } = props
  const version = run.version || '1'

  const shouldShowKibanaLink = kind === 'source' && sourceId
  const shouldShowLogDNALink = kind === 'warehouse' && version === '2' && warehouseId && sourceId

  return (
    <div className='RunAdmin'>
      <h4>Logs</h4>

      <ShowHide show={shouldShowKibanaLink}>
        <Space value='20' />
        <Link href={buildKibanaQueryUrl(sourceId, run.id)} rel='external'>Kibana</Link>
      </ShowHide>

      <ShowHide show={shouldShowLogDNALink}>
        <Space value='20' />
        <Link href={buildLogDNAQueryUrl(warehouseId, sourceId, run.id)} rel='external'>LogDNA</Link>
      </ShowHide>

      <Space value='20' />
      <Copy>Version {version}</Copy>

      <ShowHide show={run.taskArn}>
        <div className='Ecs-Logs'>
          <Space value='20' />
          <Copy>Run the following command in your dev VM to retrieve raw logs</Copy>
          <Space value='10' />
          <Code hideGutter>{`robo prod tool task ecs-logs ${run.taskArn}`}</Code>
        </div>
      </ShowHide>
    </div>
  )
}

function buildKibanaQueryUrl (sourceId, runId) {
  const protocol = 'https'
  const host = 'logs.segment.com'
  const index = 'logs-*'
  const query = `fields.project_id:${sourceId} AND fields.run_id:${runId}`
  const globalState = '(time:(from:now-60d,mode:quick,to:now))'
  const appState = `(index:'${index}',query:(query_string:(analyze_wildcard:!t,query:'${query}')),sort:!('@timestamp',desc))`

  return `${protocol}://${host}/#/discover?_g=${globalState}&_a=${appState}`
}

function buildLogDNAQueryUrl (warehouseId, sourceId, runId) {
  return format({
    protocol: 'https',
    hostname: 'app.logdna.com',
    pathname: '7d9c513b2b/logs/view',
    query: {
      q: `data.warehouse_id:${warehouseId} data.group_id:${runId} data.project_id:${sourceId}`,
      apps: 'g::9f2d0233e0'
    }
  })
}

RunAdmin.propTypes = {
  kind: PropTypes.string.isRequired,
  sourceId: PropTypes.string,
  warehouseId: PropTypes.string,
  run: PropTypes.object.isRequired
}

RunAdmin.displayName = 'RunAdmin'

export default RunAdmin



// WEBPACK FOOTER //
// ./ui/Run/run-admin.js